document.addEventListener("DOMContentLoaded",function(){ 
	initAOSClasses();
	AOS.init();
	recentjob_pagination();
	mute_unmute_herov1_video();	
	scroll_on_click_btn();
	//psHandleOverlay();
	addMegaMenuDepthTwo();
	pscommonloadMorePosts();
	pscommonloadMoreRelatedPosts();
	pssearchloadMorePosts();
	// recent_joblisting_scrolling();
	handleStickyHeaderOnScroll();
	pscarouselslidernavigation();

	netflixmenufunctionality();
	ps_addGalleryArrow();
    make_job_card_clickable();
 })
//Initialize Accordion
if (document.querySelector(".accordion-container")) {
	new Accordion(".accordion-container");
}

// version 2 carousel
if (document.querySelector(".ps-carousel-two")) {
    var allSlides = document.querySelectorAll(".ps-carousel-two .glide");
    var allSlidesArray = Array.prototype.slice.call(allSlides);
    allSlidesArray.forEach((slide) => {
        const glide = new Glide(slide, {
            type: "carousel",
            perView: 1, // Display 4 slides per view by default
            perTouch: 1,
            focusAt: 0, // Focus on the first slide
            autoplay: false,
            accessibility: true,
            startAt: 0,
            rewind: true,
            draggable: true,
            swipeThreshold: 80,
            dragThreshold: 120,
            classes: {
                disabledArrow: "glide__arrow--disabled",
            },
            peek: {
                before: 0, // No peek before, showing the full leftmost slide
                after: 0, // Showing half of the rightmost slide
            },
            // breakpoints: {
            //     800: {
            //         perView: 1, // Show 3 slides per view on smaller screens (mobile)
            //         perTouch: 1,
            //         draggable: true,
            //         startAt: 0,
            //         peek: 0,
            //         swipeThreshold: 10,
            //         dragThreshold: 20,
            //     },
			// 	peek: {
			// 		before: 100, // No peek before, showing the full leftmost slide
			// 		after: 150, // Showing half of the rightmost slide
			// 	},
            // }
        }).mount();

        const glideSlides = slide.querySelector(".glide__slides");
        const slides = glideSlides.querySelectorAll("li");

        slides.forEach((li, index) => {
            console.log(`Width of slide ${index + 1}: ${li.offsetWidth}px`);
        });
    });
}



//Check if Header Button link is external
const btns = document.querySelectorAll(".wp-block-button__link");
const allBtns = Array.prototype.slice.call(btns);
const currentHost = window.location.hostname;

let externalText = document.createElement("span");
externalText.append(document.createTextNode("link will open external site"));
externalText.classList.add("screen-reader-text");

if (btns) {
	allBtns.forEach((btn) => {
		if (btn.hasAttribute("href")) {
			let ctaLink = btn.getAttribute("href").split("/");

			if (ctaLink[2] !== currentHost) {
				btn.classList.add("external-link");
				btn.append(externalText);
			}
		}
	});
}
if (document.querySelector(".cta-btn")) {
	let currentHost = window.location.hostname;
	let ctaBtn = document.querySelector(".cta-btn");
	let ctaLink = ctaBtn.getAttribute("href").split("/");

	if (ctaLink[0] !== currentHost) {
		ctaBtn.classList.add("external-link");
		ctaBtn.append(externalText);
	}
}


////Pagination
if (document.querySelector(".navigation-pagination")) {
	let paginationList = document.querySelectorAll(".navigation-pagination ul li");

	if (paginationList[0].classList.contains("active")) {
		paginationList[0].style.position = "relative";
	}

	if (paginationList[paginationList.length - 1].classList.contains("active")) {
		paginationList[paginationList.length - 1].style.position = "relative";
	}
}

////Masonary
if (document.querySelector(".allcontainer")) {
	var elem = document.querySelector(".allcontainer");
	var msnry = new Masonry(elem, {
		// options
		itemSelector: ".item",
		columnWidth: ".grid-sizer",
		gutter: 15,
	});

	//Filters
	// const filterBtn = document.querySelectorAll('.filters button');
	// var allfilterBtn = Array.prototype.slice.call(filterBtn);
	//let allblocks = document.querySelectorAll('.item');
	let allblocks = Array.prototype.slice.call(document.querySelectorAll(".item"));
	let selectedValue;
	let selectedOption;
	let availableItems;
	let buttons = document.querySelectorAll(".filters button"); //returns a nodelist

	for (let i = 0; i < buttons.length; i++) {
		buttons[i].addEventListener("click", onClickChange);
	}

	//Click Filter
	function onClickChange() {
		selectedValue = this.value;
		// if(selectedValue !== 'all'){
		//   allblocks = document.querySelectorAll('.item.block');
		// }
		allblocks.forEach(function (block) {
			block.classList.remove("block");

			if (selectedValue == "all") {
				block.classList.add("block");
			}

			if (block.getAttribute("data-cat") == selectedValue) {
				block.classList.add("block");
			}
		});
		msnry.layout();

		availableItems = Array.prototype.slice.call(document.querySelectorAll(".item.block"));
		document.getElementById("select").addEventListener("change", onSelectChange);
	}

	availableItems = Array.prototype.slice.call(document.querySelectorAll(".item.block"));

	document.getElementById("select").addEventListener("change", onSelectChange);

	function onSelectChange() {
		selectedOption = this.value;

		availableItems.forEach(function (item) {
			item.classList.remove("block");

			if (selectedOption == "all") {
				item.classList.add("block");
			}

			if (item.getAttribute("data-tag") == selectedOption) {
				item.classList.add("block");
			}
		});

		//Filter Click
		for (let i = 0; i < buttons.length; i++) {
			buttons[i].addEventListener("click", onClickChange);
		}

		msnry.layout();
	}

	/////Script_AJAX
	/* Ajax functions */
	$(document).ready(function () {
		//onclick
		$("#loadMore").on("click", function (e) {
			e.preventDefault();
			//init
			var that = $(this);
			var page = $(this).data("page");
			var newPage = page + 1;
			var ajaxurl = that.data("url");
			//ajax call
			$.ajax({
				url: ajaxurl,
				type: "post",
				data: {
					page: page,
					action: "ajax_script_load_more",
				},
				error: function (response) {
					console.log(response);
				},
				success: function (response) {
					//check
					if (response == 0) {
						$(".allcontainer").append('<div class="text-center no-more-post"><h4>You reached the end of the line!</h4><p>No more posts to load.</p></div>');
						$("#loadMore").hide();
					} else {
						that.data("page", newPage);
						$("#ajax-primary").append(response);

						msnry = new Masonry(elem, {
							// options
							itemSelector: ".item",
							columnWidth: ".grid-sizer",
							gutter: 15,
						});

						msnry.layout();
					}
				},
			});
		});
	});
}


//Button Custom Colors Hover
var customBtn = $(".wp-block-button a.has-text-color.has-background");

customBtn.each(function (index) {
	var btnbgColor = $(this).css("backgroundColor");
	var btnColor = $(this).css("color");

	$(this)
		.mouseenter(function () {
			$(this).css({
				"background-color": btnColor,
				color: btnbgColor,
				"border-color": btnColor
			});
		})
		.mouseleave(function () {
			$(this).css({
				"background-color": btnbgColor,
				color: btnColor,
				"border-color": btnbgColor
			});
		});
});

// global classes for animations
function initAOSClasses() {
	let all_firstslide = document.querySelectorAll(".aos-fade-left-five-h");
	let all_secondslide = document.querySelectorAll(".aos-fade-left-eight-h");
	let all_thirdslide = document.querySelectorAll(".aos-fade-left-twelve-h");
	//  Fade left animation
	let aos_fade_left_animation = document.querySelectorAll(".aos-fade-left");
	//  Fade right animation
	let aos_fade_right_animation = document.querySelectorAll(".aos-fade-right");
	//  Fade right animation slow
	let aos_fade_right_slow_animation = document.querySelectorAll(".aos-fade-right-slow");
	//  Fade up animation
	let aos_fade_up_animation = document.querySelectorAll(".aos-fade-up");
	//  Fade down animation
	let aos_fade_down_animation = document.querySelectorAll(".aos-fade-down");
	//  Zoom in animation
	let aos_zoom_in_animation = document.querySelectorAll(".aos-zoom-in");
	//  Zoom out animation
	let aos_zoom_out_animation = document.querySelectorAll(".aos-zoom-out");

	//  Flip left animation
	let aos_flip_left_animation = document.querySelectorAll(".aos-flip-left");
	//  Flip right animation
	let aos_flip_right_animation = document.querySelectorAll(".aos-flip-right");
	//  Flip up out animation
	let aos_flip_up_animation = document.querySelectorAll(".aos-flip-up");
	//  Flip down animation
	let aos_flip_down_animation = document.querySelectorAll(".aos-flip-down");
	//  Zoom in up animation
	let aos_zoom_in_up_animation = document.querySelectorAll(".aos-zoom-in-up");
	//  Zoom in down animation
	let aos_zoom_in_down_animation = document.querySelectorAll(".aos-zoom-in-down");
	//  Zoom in left animation
	let aos_zoom_in_left_animation = document.querySelectorAll(".aos-zoom-in-left");
	//  Zoom in right animation
	let aos_zoom_in_right_animation = document.querySelectorAll(".aos-zoom-in-right");
  
	if (all_firstslide) {
	  for (let i = 0; i < all_firstslide.length; i++) {
		all_firstslide[i].setAttribute("data-aos", "fade-left");
		all_firstslide[i].setAttribute("data-aos-duration", "500");
		// all_firstslide[i].setAttribute("data-aos-offset","100");
	  }
	}
	if (all_secondslide) {
	  for (let i = 0; i < all_secondslide.length; i++) {
		all_secondslide[i].setAttribute("data-aos", "fade-left");
		all_secondslide[i].setAttribute("data-aos-duration", "800");
		// all_secondslide[i].setAttribute("data-aos-offset","400");
	  }
	}
	if (all_thirdslide) {
	  for (let i = 0; i < all_thirdslide.length; i++) {
		all_thirdslide[i].setAttribute("data-aos", "fade-left");
		all_thirdslide[i].setAttribute("data-aos-duration", "1200");
		// all_thirdslide[i].setAttribute("data-aos-offset","800");
	  }
	}
  
	//  Fade left animation
	if (aos_fade_left_animation) {
	  for (let i = 0; i < aos_fade_left_animation.length; i++) {
		aos_fade_left_animation[i].setAttribute("data-aos", "fade-left");
	  }
	}
	//  Fade right animation
	if (aos_fade_right_animation) {
	  for (let i = 0; i < aos_fade_right_animation.length; i++) {
		aos_fade_right_animation[i].setAttribute("data-aos", "fade-right");
	  }
	}
	//  Fade right animation slow
	if (aos_fade_right_slow_animation) {
	  for (let i = 0; i < aos_fade_right_slow_animation.length; i++) {
		aos_fade_right_slow_animation[i].setAttribute("data-aos", "fade-right");
		aos_fade_right_slow_animation[i].setAttribute(
		  "data-aos-duration",
		  "1200"
		);
	  }
	}
	//  Fade up animation
	if (aos_fade_up_animation) {
	  for (let i = 0; i < aos_fade_up_animation.length; i++) {
		aos_fade_up_animation[i].setAttribute("data-aos", "fade-up");
	  }
	}
	//  Fade down animation
	if (aos_fade_down_animation) {
	  for (let i = 0; i < aos_fade_down_animation.length; i++) {
		aos_fade_down_animation[i].setAttribute("data-aos", "fade-down");
	  }
	}
	//  Zoom in animation
	if (aos_zoom_in_animation) {
	  for (let i = 0; i < aos_zoom_in_animation.length; i++) {
		aos_zoom_in_animation[i].setAttribute("data-aos", "zoom-in");
	  }
	}
	//  Zoom out animation
	if (aos_zoom_out_animation) {
	  for (let i = 0; i < aos_zoom_out_animation.length; i++) {
		aos_zoom_out_animation[i].setAttribute("data-aos", "zoom-out");
	  }
	}
	//  Flip left animation
	if (aos_flip_left_animation) {
		for (let i = 0; i < aos_flip_left_animation.length; i++) {
			aos_flip_left_animation[i].setAttribute("data-aos", "flip-left");
		}
	  }
	//  Flip right animation
	if (aos_flip_right_animation) {
		for (let i = 0; i < aos_flip_right_animation.length; i++) {
			aos_flip_right_animation[i].setAttribute("data-aos", "flip-right");
		}
	  }
	//  Flip up out animation
	if (aos_flip_up_animation) {
		for (let i = 0; i < aos_flip_up_animation.length; i++) {
			aos_flip_up_animation[i].setAttribute("data-aos", "flip-up");
		}
	  }
	  //  Flip down animation
	if (aos_flip_down_animation) {
		for (let i = 0; i < aos_flip_down_animation.length; i++) {
			aos_flip_down_animation[i].setAttribute("data-aos", "flip-down");
		}
	  }
	  //  Zoom in up animation
	if (aos_zoom_in_up_animation) {
		for (let i = 0; i < aos_zoom_in_up_animation.length; i++) {
			aos_zoom_in_up_animation[i].setAttribute("data-aos", "zoom-in-up");
		}
	  }
	  //  Zoom in down animation
	if (aos_zoom_in_down_animation) {
		for (let i = 0; i < aos_zoom_in_down_animation.length; i++) {
			aos_zoom_in_down_animation[i].setAttribute("data-aos", "zoom-in-down");
		}
	  }
	 //  Zoom in left animation
	if (aos_zoom_in_left_animation) {
		for (let i = 0; i < aos_zoom_in_left_animation.length; i++) {
			aos_zoom_in_left_animation[i].setAttribute("data-aos", "zoom-in-left");
		}
	  }
	 //  Zoom in right animation
	if (aos_zoom_in_right_animation) {
		for (let i = 0; i < aos_zoom_in_right_animation.length; i++) {
			aos_zoom_in_right_animation[i].setAttribute("data-aos", "zoom-in-right");
		}
	  }
  };

// JavaScript code for gradient change //
const buttons = document.querySelectorAll('.wp-block-button__link');

function hasGradientBackground(element) {
	const backgroundImage = window.getComputedStyle(element).backgroundImage;
	return backgroundImage.includes('gradient');
}

function reverseGradient(element) {
	const backgroundImage = window.getComputedStyle(element).backgroundImage;
	const reversedGradient = backgroundImage.replace(/linear-gradient\(([^,]+),/, (match, p1) => {
		let newDirection;
		if (p1.includes('deg')) {
			const angle = parseFloat(p1);
			newDirection = (angle + 180) % 360 + 'deg';
		} else {
			const directions = {
				'to top': 'to bottom',
				'to bottom': 'to top',
				'to left': 'to right',
				'to right': 'to left',
				'to top left': 'to bottom right',
				'to top right': 'to bottom left',
				'to bottom left': 'to top right',
				'to bottom right': 'to top left'
			};
			newDirection = directions[p1] || p1;
		}
		return `linear-gradient(${newDirection},`;
	});
	element.style.backgroundImage = reversedGradient;
}

buttons.forEach(button => {
	if (hasGradientBackground(button)) {
		const originalBackground = window.getComputedStyle(button).backgroundImage;

		button.addEventListener('mouseover', () => {
			reverseGradient(button);
		});

		button.addEventListener('mouseout', () => {
			button.style.backgroundImage = originalBackground;
		});
	}
});

// document.addEventListener("DOMContentLoaded", function () {
//     const toggleSwitch = document.getElementById('theme-toggle');
//     const currentTheme = localStorage.getItem('theme') || 'light';
    
//     if (currentTheme === 'dark') {
//         document.body.classList.add('dark-mode');
//     }

//     toggleSwitch.addEventListener('click', function () {
//         document.body.classList.toggle('dark-mode');
//         let theme = document.body.classList.contains('dark-mode') ? 'dark' : 'light';
//         localStorage.setItem('theme', theme);
//     });
// });

// Recent job listing pagination js
function recentjob_pagination() {
    const scrollingArrowRight = document.querySelector(".job-scrolling-container .right-scrolling-arrow img");
    const jobList = document.querySelector(".job-scrolling-container .recent-job-list");
    const paginationContainer = document.querySelector(".recent-job-pagination .page-dots");

    if (!jobList || !paginationContainer) {
        // console.error("Required elements are missing in the DOM.");
        return;
    }

    const jobItems = Array.from(jobList.querySelectorAll("li"));
    if (jobItems.length === 0) {
        // console.error("No job items found.");
        return;
    }

    const totalItems = jobItems.length;
    const itemWidth = jobItems[0].offsetWidth;
    const totalWidth = itemWidth * totalItems;

    let currentIndex = 0;

    // Create and append pagination dots
    function createPagination() {
        paginationContainer.innerHTML = "";
        for (let i = 0; i < totalItems; i++) {
            const dot = document.createElement("span");
            dot.classList.add("dot");
            if (i === 0) dot.classList.add("active");
            paginationContainer.appendChild(dot);
        }
    }

    // Update active pagination dot
    function updateActivePagination() {
        const dots = paginationContainer.querySelectorAll(".dot");
        dots.forEach((dot, index) => dot.classList.toggle("active", index === currentIndex));
    }

    // Move to the next slide
    function scrollToNextSlide() {
        if (window.innerWidth > 960) {
            // For screen widths > 960px, scroll by full set of items (100%)
            const scrollDistance = totalWidth;
            jobList.scrollBy({
                left: scrollDistance,
                behavior: 'smooth'
            });
            currentIndex = (currentIndex + 1) % totalItems;
        } else {
            // For smaller screens, scroll by one item width (for smooth scrolling)
            jobList.scrollBy({
                left: itemWidth,
                behavior: 'smooth'
            });
            currentIndex = (currentIndex + 1) % totalItems;
        }

        updateActivePagination();
    }

    // Event listeners for scrolling arrows
    if (scrollingArrowRight) {
        scrollingArrowRight.addEventListener("click", scrollToNextSlide);
    }

    // Initialize pagination and update active dot
    createPagination();
    updateActivePagination();
}

// function setupPagination() {
// 	const jobList = document.querySelector('.job-scrolling-container .recent-job-list');
// 	if(jobList){
// 		const jobItems = jobList.querySelectorAll("li");

//         // Calculate the length of the list items
//         const jobCount = jobItems.length;
// 		console.log(jobItems.length);
// 	}
// 	// const dots = document.querySelectorAll('recent-job-pagination .dot');
	
	
// 	// let currentIndex = 0;
	
// 	// function updateDots() {
// 	// 	dots.forEach((dot, index) => {
// 	// 		dot.classList.toggle('active', index === currentIndex);
// 	// 	});
// 	// }

// 	// function scrollToIndex(index) {
// 	// 	const jobWidth = jobList.querySelector('li').offsetWidth;
// 	// 	jobList.scrollTo({
// 	// 		left: index * jobWidth,
// 	// 		behavior: 'smooth'
// 	// 	});
// 	// 	currentIndex = index;
// 	// 	updateDots();
// 	// }

// 	// nextButton.addEventListener('click', () => {
// 	// 	if (currentIndex < dots.length - 1) {
// 	// 		scrollToIndex(currentIndex + 1);
// 	// 	}
// 	// });

// 	// prevButton.addEventListener('click', () => {
// 	// 	if (currentIndex > 0) {
// 	// 		scrollToIndex(currentIndex - 1);
// 	// 	}
// 	// });

// 	// dots.forEach((dot, index) => {
// 	// 	dot.addEventListener('click', () => {
// 	// 		scrollToIndex(index);
// 	// 	});
// 	// });

// 	// updateDots(); // Initialize dots
// }

// document.addEventListener('DOMContentLoaded', function () {
//     setupPagination();
// });

// horizontal scroll for recent job listing 
// function recent_joblisting_scrolling(){
// 	 // Register GSAP's ScrollTrigger plugin
// 	 gsap.registerPlugin(ScrollTrigger);

// 	 // Setup horizontal scroll animation
// 	 const scrollContent = document.querySelector('.recent-job-list');
// 	 const scrollWidth = scrollContent.scrollWidth;
// 	 const containerWidth = document.querySelector('.job-scrolling-container').offsetWidth;

// 	 gsap.to(".recent-job-list", {
// 		 x: () => -(scrollWidth - containerWidth),
// 		 ease: "none",
// 		 scrollTrigger: {
// 			 trigger: ".job-scrolling-container",
// 			 start: "top top",
// 			 end: () => `+=${scrollWidth}`,
// 			 scrub: true,
// 			 pin: false,
// 			 anticipatePin: 1
// 		 }
// 	 });
// }

// function recent_joblisting_scrolling() {
// 	// Register GSAP's ScrollTrigger plugin
// 	gsap.registerPlugin(ScrollTrigger);
  
// 	// Setup horizontal scroll animation
// 	const scrollContent = document.querySelector('.recent-job-list');
// 	const scrollWidth = scrollContent.scrollWidth;  // Total width of the scrollable content
// 	const containerWidth = document.querySelector('.job-scrolling-container').offsetWidth;  // Visible area width
  
// 	// Check if the content width is greater than the container width
// 	if (scrollWidth > containerWidth) {
// 	  gsap.to(".recent-job-list", {
// 		x: () => -(scrollWidth - containerWidth), // Move horizontally
// 		ease: "none", // Ensure no easing, smooth constant scroll
// 		scrollTrigger: {
// 		  trigger: ".job-scrolling-container", // The container that triggers the scroll
// 		  start: "top top",  // Start when the container's top is at the top of the viewport
// 		  end: () => `+=${scrollWidth}`,  // End after the full scrollable content is reached
// 		  scrub: true, // Sync the animation with the scroll
// 		  pin: false, // Don't pin the content, just scroll
// 		  anticipatePin: 1, // Smooth the animation if pinning was used
// 		  markers: false  // Set to `true` to debug and visualize the ScrollTrigger start and end positions
// 		}
// 	  });
// 	}
//   }
  
function mute_unmute_herov1_video() {
    const iframe = document.querySelector(".hero-area-banner-wrap-v1 #intro_video");
    const unmuteButton = document.querySelector(".hero-area-banner-wrap-v1 .hero-area-unmute-btn");

    if (!iframe || !unmuteButton) return;

    // Initialize Vimeo Player
    const player = new Vimeo.Player(iframe);

    // Function to toggle mute/unmute
    function toggleMuteUnmute() {
        
        // Get the current volume
       // player.getVolume().then((volume) => {
            const span = unmuteButton.querySelector("span");
            if (unmuteButton.classList.contains('muted')) {
                unmuteButton.classList.remove('muted');
                player.setVolume(1).then(() => {
                           span.textContent = "mute"; // Change text to "Unmute"
                           // Optionally, change the icon here as well
                             // unmuteButton.querySelector("img").src = "path/to/unmute-icon.svg";
                    });
            } else {
                player.setVolume(0).then(() => {
                    unmuteButton.classList.toggle('muted');
                    span.textContent = "Unmute"; // Change text to "Unmute"
                    // Optionally, change the icon here as well
                      // unmuteButton.querySelector("img").src = "path/to/unmute-icon.svg";
             });

            }
            // If the volume is 0 (muted), unmute it
            // if (volume === 0) {
            //     player.setVolume(0).then(() => {
            //         span.textContent = "Mute"; // Change text to "Mute"
            //         // Optionally, change the icon here as well
            //         // unmuteButton.querySelector("img").src = "path/to/mute-icon.svg";
            //     });
            // } else {
            //     // If the volume is > 0 (unmuted), mute it
            //     player.setVolume(1).then(() => {
            //         span.textContent = "Unmute"; // Change text to "Unmute"
            //         // Optionally, change the icon here as well
            //         // unmuteButton.querySelector("img").src = "path/to/unmute-icon.svg";
            //     });
            // }

            // Toggle class on the button each time it's clicked
           // unmuteButton.classList.toggle('muted'); // Replace 'muted' with your desired class
       // });
    }

    // Event listener for the Unmute button (mouse click)
    unmuteButton.addEventListener("click", (e) => {
        e.preventDefault();
        toggleMuteUnmute();
    });

    // Handle keyboard events (Enter or Space key)
    unmuteButton.addEventListener("keydown", (e) => {
        if (e.key === 'Enter' || e.key === ' ') { // Enter or Space key
            e.preventDefault(); // Prevent the default behavior (e.g., scrolling)
            toggleMuteUnmute();
        }
    });
}


// Scroll by 80% on click of hero banner
  function scroll_on_click_btn() {
	var scrollBannerBtn = document.querySelector('.scroll-banner-btn');
	if (scrollBannerBtn) {
	  scrollBannerBtn.addEventListener('click', function() {
		const headerHeight = 79;
		const heroAreaHeight = window.innerHeight * 0.8;
		const scrollAmount = heroAreaHeight - headerHeight;
		window.scrollBy(0, scrollAmount); // Scroll by the calculated amount
	  });
	}
  }


function psHandleOverlay() {
// Select all .card-img-wrapper elements
if (window.innerWidth <= 960) {
const cardWrappers = document.querySelectorAll('.ps-infocard-component-layout-v7 .card-img-wrapper');
if(cardWrappers){
cardWrappers.forEach(function(cardWrapper) {
    // Find the overlay and the link inside the current card
    const overlay = cardWrapper.querySelector('.overlay');
    const link = cardWrapper.querySelector('.card-link');  // Access the anchor link

    // Initially hide the overlay
    overlay.style.display = "none";

    // Add click event listener to the image container (the card wrapper)
    cardWrapper.addEventListener('click', function(event) {
        // If the overlay is not visible, show it and prevent the link's default behavior
        if (overlay.style.display === "none" || overlay.style.display === "") {
            overlay.style.display = "flex"; // Show the overlay
            event.preventDefault(); // Prevent link redirection
        }
    });

    // Add click event listener to the link inside the overlay
    link.addEventListener('click', function(e) {
        // If the overlay is visible, allow the link to work normally
        if (overlay.style.display === "flex") {
            // No need to prevent default here; let the link redirect
            return;
        }
        // Prevent redirect if the overlay is still hidden (on first click)
        e.preventDefault();
    });
});
}
}
}

if (document.querySelector(".ps-carousel-recent-job-listing")) {
	//if (document.querySelector(".glide__slides")) {
		var allSlides = document.querySelectorAll(".ps-carousel-recent-job-listing .glide");
		var allSlidesArray = Array.prototype.slice.call(allSlides);
        allSlidesArray.forEach((slide) => {
            const glide = new Glide(slide, {
                type: "slider",
                perView: 5,
                perTouch: 1,
                focusAt: 0,
                autoplay: false,
                accessibility: true,
                keyboard: true,
                startAt: 0,
                rewind: true,
                draggable: true,
                swipeThreshold: 80,
                dragThreshold: 120,
                classes: {
                    disabledArrow: "glide__arrow--disabled",
                },
                breakpoints: {
                    1400: { perView: 4, draggable: true, peek: { before: 0, after: 50 }, swipeThreshold: 10, dragThreshold: 20 },
                    1280: { perView: 4, draggable: true, peek: { before: 0, after: 50 }, swipeThreshold: 10, dragThreshold: 20 },
                    1080: { perView: 3, draggable: true, peek: { before: 0, after: 50 }, swipeThreshold: 10, dragThreshold: 20 },
                    800:  { perView: 2, draggable: true, peek: { before: 0, after: 50 }, swipeThreshold: 10, dragThreshold: 20 },
                    560:  { perView: 1, draggable: true, peek: { before: 0, after: 50 }, swipeThreshold: 10, dragThreshold: 20 },
                    480:  { perView: 1, draggable: true, peek: { before: 0, after: 50 }, swipeThreshold: 10, dragThreshold: 20 },
                },
            });
        
            glide.on('mount.after', () => {
                const slides = slide.querySelectorAll('.glide__slide');
                const controls = slide.querySelector('.glide__controls');
                const bullets = slide.querySelector('.glide__bullets');
        
                // Get current perView based on active settings
                let currentPerView = glide.settings.perView;
        
                // Check if responsive breakpoints override it
                const breakpoints = glide.settings.breakpoints || {};
                const sortedBreakpoints = Object.keys(breakpoints).map(n => parseInt(n)).sort((a, b) => b - a);
                for (let bp of sortedBreakpoints) {
                    if (window.innerWidth <= bp && breakpoints[bp].perView) {
                        currentPerView = breakpoints[bp].perView;
                    }
                }
        
                if (slides.length <= currentPerView) {
                    if (controls) controls.style.display = 'none';
                    if (bullets) bullets.style.display = 'none';
                }
            });
        
            glide.mount();
        });
        
		// allSlidesArray.forEach((slide) => {
		// 	const glide = new Glide(slide, {
		// 		type: "slider",
		// 		perView: 5, // Display 4 slides per view
		// 		perTouch: 1,
		// 		focusAt: 0, // Focus on the first slide
		// 		autoplay: false,
		// 		accessibility: true,
		// 		keyboard: true,
		// 		startAt: 0,
		// 		rewind: true,
		// 		draggable: true,
		// 		swipeThreshold: 80,
		// 		dragThreshold: 120,
		// 		classes: {
		// 			disabledArrow: "glide__arrow--disabled",
		// 		},
		// 		breakpoints: {
        //             1400: {
		// 				perView: 4, // Adjust for smaller screens if necessary
		// 				draggable: true,
		// 				perTouch: 1,
		// 				startAt: 0,
		// 				peek: { before: 0, after: 50 },
		// 				swipeThreshold: 10,
		// 				dragThreshold: 20,
		// 			},
        //             1280: {
		// 				perView: 4, // Adjust for smaller screens if necessary
		// 				draggable: true,
		// 				perTouch: 1,
		// 				startAt: 0,
		// 				peek: { before: 0, after: 50 },
		// 				swipeThreshold: 10,
		// 				dragThreshold: 20,
		// 			},
		// 			1080: {
		// 				perView: 3, // Adjust for smaller screens if necessary
		// 				draggable: true,
		// 				perTouch: 1,
		// 				startAt: 0,
		// 				peek: { before: 0, after: 50 },
		// 				swipeThreshold: 10,
		// 				dragThreshold: 20,
		// 			},
		// 			800: {
		// 				perView: 2, // Adjust for smaller screens if necessary
		// 				draggable: true,
		// 				perTouch: 1,
		// 				startAt: 0,
		// 				peek: { before: 0, after: 50 },
		// 				swipeThreshold: 10,
		// 				dragThreshold: 20,
		// 			},
		// 			560: {
		// 				perView: 1, // Adjust for smaller screens if necessary
		// 				draggable: true,
		// 				perTouch: 1,
		// 				startAt: 0,
		// 				peek: { before: 0, after: 50 },
		// 				swipeThreshold: 10,
		// 				dragThreshold: 20,
		// 			},
		// 			480: {
		// 				perView: 1, // Adjust for smaller screens if necessary
		// 				draggable: true,
		// 				perTouch: 1,
		// 				startAt: 0,
		// 				peek: { before: 0, after: 50 },
		// 				swipeThreshold: 10,
		// 				dragThreshold: 20,
		// 			}
	
		// 		},
		// 	}).mount();
        //     // hide .glide__controls and .glide__bullets when total slides are less or equals to perview
		// });
	//}
}  

function addMegaMenuDepthTwo() {
    // Find all <ul> elements with the class 'level-2' inside '.submenu-inner'
    var levelTwoMenus = document.querySelectorAll('.submenu-inner ul.level-2');

    // Check if any matching <ul> elements are found
    if (levelTwoMenus.length > 0) {
        levelTwoMenus.forEach(function(menu) {
            // Find and remove all 'span' elements with the class 'ps-menu-link' inside this level-2 menu
            var psMenuLinks = menu.querySelectorAll('span.ps-menu-link');
            psMenuLinks.forEach(function(span) {
                span.remove(); // Remove the span element from level-2
            });

            // Find the closest parent 'ul' with the class 'level-1' of the current 'level-2' menu
            var parentMenu = menu.closest('.desktop-menu .sub-menu.level-1');
            if (parentMenu) {
                // Remove the 'ps-menu-link' span elements from the parent menu (level-1)
                var parentPsMenuLinks = parentMenu.querySelectorAll('span.ps-menu-link');
                parentPsMenuLinks.forEach(function(span) {
                    span.remove(); // Remove the span element from the parent menu
                });
                
                // Add 'has-level-two' class to the parent 'ul.level-1'
                parentMenu.classList.add('has-level-two');
            }
			// Find the closest parent 'ul' with the class 'level-1' of the current 'level-2' menu
            var parentMenu = menu.closest('.mobile-menu .sub-menu.level-1');
            if (parentMenu) {
                // Remove the 'ps-menu-link' span elements from the parent menu (level-1)
                var parentPsMenuLinks = parentMenu.querySelectorAll('span.ps-menu-link');
                parentPsMenuLinks.forEach(function(span) {
                  //  span.remove(); // Remove the span element from the parent menu
                });
                
                // Add 'has-level-two' class to the parent 'ul.level-1'
                parentMenu.classList.add('has-level-two');
            }
			var submenuwrapper = menu.closest('.submenu-wrapper');
            if (submenuwrapper) {   
                // Add 'has-level-two' class to the parent 'ul.level-1'
                submenuwrapper.classList.add('has-level-two-wrapper');
            }
        });
    }
}




// postlisting ajax code
function pscommonloadMorePosts() {
    let page = 2; // Start from the first page
    let isLoading = false;
    let debounceTimeout; // Timeout variable to handle debouncing

    const loadMoreButton = document.getElementById('load-more-post-btn');
    if (!loadMoreButton) return; // Return if the button doesn't exist
    
    loadMoreButton.addEventListener('click', function() {
        if (isLoading) return; // Prevent multiple requests while loading
        
        // Clear the previous debounce timeout
        clearTimeout(debounceTimeout);

        // Set a new debounce timeout
        debounceTimeout = setTimeout(function() {
            isLoading = true;

            const msperpage = loadMoreButton.getAttribute("data-msperpage");
            const postNotIn = loadMoreButton.getAttribute("data-post_not_in");
			const pslayout = loadMoreButton.getAttribute("data-pslayout");
			const categoryid = loadMoreButton.getAttribute("data-categoryid");
            const psloadBtnText = loadMoreButton.querySelector('.post-load-btn-text');
            const psoriginalText = psloadBtnText.textContent;
            psloadBtnText.textContent = 'Loading...';
			
            // Dynamically construct the API URL based on the current site URL
            //const apiUrl = `${window.location.origin}/wp-json/ps/v1/pspostlisting`;
			var apiUrl = window.location.hostname === 'localhost' ? siteData.siteUrl+'/wp-json/ps/v1/pspostlisting' : '/wp-json/ps/v1/pspostlisting';

            const data = {
                page: page,
                mpperpage: msperpage,
				pslayout: pslayout,
                post_not_in: postNotIn // Make sure this is serialized on the backend
            };

            fetch(apiUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            })
            .then(response => response.json())
            .then(json_html => {
                if (json_html.max === 1) {
                    loadMoreButton.style.display = 'none'; // Hide button if no more posts
                }

                document.querySelector('.all-articles').innerHTML += json_html.html; // Append new posts
                isLoading = false;
                psloadBtnText.textContent = psoriginalText;
                page++; // Increment the page for the next request
            })
            .catch(error => {
                isLoading = false;
                psloadBtnText.textContent = psoriginalText;
            });
        }, 300); // 300ms debounce time (adjust as needed)
    });
}


// search postlisting ajax code
function pssearchloadMorePosts() {
    let page = 2; // Start from the first page
    let isLoading = false;
    let debounceTimeout; // Timeout variable to handle debouncing

    const loadMoreButton = document.getElementById('load-more-search-btn');
    if (!loadMoreButton) return; // Return if the button doesn't exist
    
    loadMoreButton.addEventListener('click', function() {
        if (isLoading) return; // Prevent multiple requests while loading
        
        // Clear the previous debounce timeout
        clearTimeout(debounceTimeout);

        // Set a new debounce timeout
        debounceTimeout = setTimeout(function() {
            isLoading = true;

            const msperpage = loadMoreButton.getAttribute("data-msperpage");
			const keyword = loadMoreButton.getAttribute("data-keyword");
            const psloadBtnText = loadMoreButton.querySelector('.post-load-btn-text');
            const psoriginalText = psloadBtnText.textContent;
            psloadBtnText.textContent = 'Loading...';
			
            // Dynamically construct the API URL based on the current site URL
            //const apiUrl = `${window.location.origin}/wp-json/ps/v1/pspostlisting`;
			var apiUrl = siteData.siteUrl+'/wp-json/ps/v1/pssearchpostlisting';

            const data = {
                page: page,
				keyword: keyword,
                mpperpage: msperpage
            };

            fetch(apiUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            })
            .then(response => response.json())
            .then(json_html => {
                if (json_html.max === 1) {
                    loadMoreButton.style.display = 'none'; // Hide button if no more posts
                }
				let allArticleSearchSection = document.querySelector('.all-articles-search-section');
				if(allArticleSearchSection){
					allArticleSearchSection.innerHTML += json_html.html; // Append new posts
				}
                isLoading = false;
                psloadBtnText.textContent = psoriginalText;
                page++; // Increment the page for the next request
            })
            .catch(error => {
                isLoading = false;
                psloadBtnText.textContent = psoriginalText;
            });
        }, 300); // 300ms debounce time (adjust as needed)
    });
}

function handleStickyHeaderOnScroll() {
    if (screen.width > 960) {
        var previousScrollpos = window.scrollY;

        window.addEventListener("scroll", (event) => {
            var currentScrollPos = window.scrollY;
            let site_header = document.querySelector("header.site-header");
            let ps_position = (site_header) ? 'fixed' : 'relative';

            // Check if the header or any of its children are focused or hovered
            const isHeaderFocusedOrHovered = site_header.matches(':hover, :focus-within');

            // Handle scroll up (show header)
            if (previousScrollpos > currentScrollPos) {
                site_header.style.top = "0";
                site_header.classList.add("header-show");
                site_header.style.position = 'fixed';
            } else { // Handle scroll down (hide header)
                if (!isHeaderFocusedOrHovered && currentScrollPos > 100) {
                    site_header.style.top = "-100px";
                    site_header.classList.remove("header-show");
                    site_header.style.position = ps_position;
                }
            }

            // Reset header position if at the top of the page
            if (currentScrollPos < 100) {
                site_header.style.position = ps_position;
                site_header.classList.remove("header-show");
            }

            // Update previous scroll position
            previousScrollpos = currentScrollPos;
        });
    }
}

// navigation carousel
function pscarouselslidernavigation() {
    if (document.querySelector(".ps-carousel-slider-navigation")) {
        var allSlides = document.querySelectorAll(".ps-carousel-slider-navigation .glide");
        if (allSlides.length > 0) {
            var allSlidesArray = Array.prototype.slice.call(allSlides);
            allSlidesArray.forEach((slide) => {
                const glide = new Glide(slide, {
                    type: "carousel",
                    perView: 4, // Display 1 slide per view by default
                    perTouch: 1,
                    focusAt: 0, // Focus on the first slide
                    autoplay: false,
                    accessibility: true,
                    startAt: 0,
                    rewind: true,
                    draggable: true,
                    swipeThreshold: 80,
                    dragThreshold: 120,
                    classes: {
                        disabledArrow: "glide__arrow--disabled",
                    },
					peek: {
                        before: 0,  // Default peek settings for larger screens
                        after: 0,
                    },
                    breakpoints: {
                        800: {
                            perView: 1.2, // Show 1.2 slides per view on smaller screens (mobile)
                            perTouch: 1,
                            draggable: true,
                            startAt: 0,
                            swipeThreshold: 10,
                            dragThreshold: 20,
                            peek: {
                                before: 0,  // No peek before, showing the full leftmost slide
                                after: 100, // Show half of the rightmost slide
                            },
                        },
                    },
                    peek: {
                        before: 0,  // Default peek settings for larger screens
                        after: 0,
                    },
                }).mount();
            });
        }
    }
}


function netflixmenufunctionality() { 
    // Select all eye icons within cards
    const eyeIcons = document.querySelectorAll(".ps-carousel-slider-navigation .card .eye-icon");
	const crossIcons = document.querySelectorAll(".ps-carousel-slider-navigation .card .cross-icon");

    if (eyeIcons) {
        // Media query for screens smaller than 960px
        if (window.innerWidth < 960) {
            eyeIcons.forEach((icon) => {
                if (icon) {
                    icon.addEventListener("click", function () {
                        // Find the parent navigation element
                        const navigationElement = document.querySelector(".ps-carousel-slider-navigation");

                        // Find the parent li element
                        const card = this.closest("li");

                        if (navigationElement && card) {
                            // Remove 'expanded-card' class from all cards
                            navigationElement.querySelectorAll("li")
                                .forEach((tile) => tile.classList.remove("expanded-card"));

                            // Remove 'expanded-navigation' class from the navigation element
                            navigationElement.classList.remove("expanded-navigation");

                            // Add 'expanded-card' to the clicked card
                            card.classList.add("expanded-card");

                            // Add 'expanded-navigation' to the navigation element
                            navigationElement.classList.add("expanded-navigation");
                        }
                    });
                }
            });
        }
    }

    if (crossIcons) {
        crossIcons.forEach((icon) => {
            if (icon) {
                icon.addEventListener("click", function () {
                    // Find the parent navigation element
                    const navigationElement = document.querySelector(".ps-carousel-slider-navigation");

                    // Find the parent li element
                    const card = this.closest("li");

                    if (navigationElement && card) {
                        // Remove 'expanded-card' from the clicked card
                        card.classList.remove("expanded-card");

                        // Check if any cards are still expanded
                        const anyExpanded = navigationElement.querySelector("li.expanded-card");

                        // If no cards are expanded, remove 'expanded-navigation' from the navigation element
                        if (!anyExpanded) {
                            navigationElement.classList.remove("expanded-navigation");
                        }
                    }
                });
            }
        });
    }
	
}

function ps_addGalleryArrow() {
	const divs = document.querySelectorAll('.gallery-component-manual.wp-block-columns.is-not-stacked-on-mobile');

    if (divs.length > 0) {
        for (let i = 0; i < divs.length; i++) {
            const div = divs[i];
            const span = document.createElement('span');
            span.className = 'scroll-button-nonstack-gallery';
            span.textContent = '';
            span.style.cursor = 'pointer';

            const hideButton = () => {
                span.style.display = 'none';
                div.removeEventListener('scroll', onScroll);
            };

            const onScroll = () => {
                if (div.scrollLeft > 0) {
                    hideButton();
                }
            };

            span.addEventListener('click', function() {
                hideButton();
                div.scrollBy({
                    left: window.innerWidth * 0.8,
                    behavior: 'smooth'
                });
            });

            div.addEventListener('scroll', onScroll);

            div.appendChild(span);
        }
    }
}
  
  
// postlisting ajax code
function pscommonloadMoreRelatedPosts() {
    let page = 2; // Start from the first page
    let isLoading = false;
    let debounceTimeout; // Timeout variable to handle debouncing

    const loadMoreButton = document.getElementById('load-more-related-post-btn');
    if (!loadMoreButton) return; // Return if the button doesn't exist
    
    loadMoreButton.addEventListener('click', function() {
        if (isLoading) return; // Prevent multiple requests while loading
        
        // Clear the previous debounce timeout
        clearTimeout(debounceTimeout);

        // Set a new debounce timeout
        debounceTimeout = setTimeout(function() {
            isLoading = true;

            const msperpage = loadMoreButton.getAttribute("data-msperpage");
            const postNotIn = loadMoreButton.getAttribute("data-post_not_in");
			const pslayout = loadMoreButton.getAttribute("data-pslayout");
			const categoryid = loadMoreButton.getAttribute("data-categoryid");
			const psloadBtnText = loadMoreButton.querySelector('.post-load-btn-text');
            const psoriginalText = psloadBtnText.textContent;
            psloadBtnText.textContent = 'Loading...';
            // Dynamically construct the API URL based on the current site URL
            //const apiUrl = `${window.location.origin}/wp-json/ps/v1/pspostlisting`;
			var apiUrl = window.location.hostname === 'localhost' ? siteData.siteUrl+'/wp-json/ps/v1/pspostlisting' : '/wp-json/ps/v1/pspostlisting';

            const data = {
                page: page,
                mpperpage: msperpage,
				pslayout: pslayout,
				categoryid: categoryid,
                post_not_in: postNotIn // Make sure this is serialized on the backend
            };

            fetch(apiUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            })
            .then(response => response.json())
            .then(json_html => {
                if (json_html.max === 1) {
                    loadMoreButton.style.display = 'none'; // Hide button if no more posts
                }

                document.querySelector('.related-posts').innerHTML += json_html.html; // Append new posts
                isLoading = false;
                psloadBtnText.textContent = psoriginalText;
                page++; // Increment the page for the next request
            })
            .catch(error => {
               // console.error('Error:', error);
                isLoading = false;
                psloadBtnText.textContent = psoriginalText;
            });
        }, 300); // 300ms debounce time (adjust as needed)
    });
}


function make_job_card_clickable(){
    const jobItems = document.querySelectorAll('ul.recent-job-list li');

    jobItems.forEach(li => {
      const link = li.querySelector('a.job-apply-link') || li.querySelector('h2 a');
      const title = li.querySelector('h2 a');
      if (!link || !title) return;
  
      // Make entire <li> clickable
      let anchors = li.querySelectorAll("a");
        if(anchors){
            anchors.forEach(anchor =>{
                anchor.setAttribute('tabindex','-1');
            })
        }
      li.setAttribute('tabindex', '0'); // Focusable with keyboard
     // li.setAttribute('role', 'link');  // Screen readers treat it like a link
      li.setAttribute('aria-label', `View job: ${title.textContent.trim()}`);
  
      // Click handler
      li.addEventListener('click', () => {
        window.location.href = link.href;
      });
  
      // Keyboard accessibility (Enter or Space)
      li.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          link.click();
        }
      });
    });
}

// expanging accordion js
// expanding accordion js (Android-friendly)
(function () {
  const COLLAPSED_PX = 45; // collapsed height
  const container = document.querySelector(".expanding-boxes__row"); // parent of the <li> items
  if (!container) return;

  const isMobile = () => window.innerWidth < 960;

  function closeItem(li) {
    const content = li.querySelector(".expanding-boxes__content");
    if (!content) return;
    // lock current height, then animate down
    content.style.maxHeight = content.scrollHeight + "px";
    requestAnimationFrame(() => {
      content.style.maxHeight = COLLAPSED_PX + "px";
    });
    li.classList.remove("active");
  }

  function openItem(li) {
    const content = li.querySelector(".expanding-boxes__content");
    if (!content) return;
    li.classList.add("active");
    // animate to natural height
    content.style.maxHeight = content.scrollHeight + "px";
  }

  function handleToggle(li) {
    // close others
    container.querySelectorAll("li.expanding-boxes__box.active").forEach(other => {
      if (other !== li) closeItem(other);
    });
    // toggle current
    if (li.classList.contains("active")) closeItem(li);
    else openItem(li);
  }

  function onPointer(e) {
    if (!isMobile()) return;
    const arrow = e.target.closest("span.arrow");
    if (!arrow || !container.contains(arrow)) return;

    // Prevent click navigation / double-fire on Android
    e.preventDefault();

    const li = arrow.closest("li.expanding-boxes__box");
    if (li) handleToggle(li);
  }

  // Bind once using Pointer Events (fallback to touch/click where needed)
  if (window.PointerEvent) {
    container.addEventListener("pointerup", onPointer, { passive: false });
  } else {
    container.addEventListener("touchend", onPointer, { passive: false });
    container.addEventListener("click", onPointer, false);
  }

  // Keep open panels sized correctly on resize
  function recalcOpenHeights() {
    if (!isMobile()) {
      // reset when leaving mobile
      container.querySelectorAll(".expanding-boxes__content").forEach(el => {
        el.style.maxHeight = "";
      });
      container.querySelectorAll("li.expanding-boxes__box.active").forEach(li => {
        li.classList.remove("active");
      });
      return;
    }
    container
      .querySelectorAll("li.expanding-boxes__box.active .expanding-boxes__content")
      .forEach(el => (el.style.maxHeight = el.scrollHeight + "px"));
  }
  window.addEventListener("resize", recalcOpenHeights);
})();

// expanding accordion js
// function initResponsiveAccordion() {
//   function applyAccordionBehavior() {
    
//     const isMobile = window.innerWidth < 960;
    
//     document.querySelectorAll("li.expanding-boxes__box").forEach(li => {
//       const arrow = li.querySelector("span.arrow");
        
//       if (!arrow) return;

//       if (isMobile) {
        
//         // Remove tabindex from li and set on arrow
//         li.removeAttribute("tabindex");
//         arrow.setAttribute("tabindex", "0");

//         // Prevent duplicate listeners
//        // if (!arrow.dataset.bound) {
            
//           arrow.addEventListener("click", function (e) {
//             e.stopPropagation();
            
//             // Remove active class from all other li elements
//             document.querySelectorAll("li.expanding-boxes__box.active").forEach(otherLi => {
//               if (otherLi !== li) {
               
//                 otherLi.classList.remove("active");
                
//               }
//             });

//             // Toggle active class on current li
//              li.classList.toggle("active");
//           });
//        //   arrow.dataset.bound = "true";
//        // }
//       } else {
       
//         // Reset on desktop
//         if (!li.hasAttribute("tabindex")) {
            
//           li.setAttribute("tabindex", "0");
//         }
//         arrow.removeAttribute("tabindex");
//       }
//     });
//   }

//   // Run on load and resize
//   applyAccordionBehavior();
//   window.addEventListener("resize", applyAccordionBehavior);
// }

// document.addEventListener("DOMContentLoaded", initResponsiveAccordion);
